import Vue from  "vue";
import buttonLink from "./button-link.vue";
import iconLink from "../shared/links/link.vue";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("button-link").forEach(function (el) {
    const anchor = el.querySelector('a');
    if (anchor) {
      const href = anchor.getAttribute('href');
      const text = anchor.innerHTML;
      const gtm = anchor.getAttribute('data-gtm');

      new Vue({
        el: el,
        components: { buttonLink },
        data: {url: href, gtm: gtm, text: text},
        template: '<button-link :url="url" :gtm="gtm" :text="text" />'
      });
    }
  });

  document.querySelectorAll("icon-link").forEach(function (el) {
    const anchor = el.querySelector('a');
    if (anchor) {
      const href = anchor.getAttribute('href');
      const text = anchor.innerHTML;
      const external = el.hasAttribute('external');
      const gtm = anchor.getAttribute('data-gtm') ? anchor.getAttribute('data-gtm') : '';

      new Vue({
        el: el,
        components: { iconLink },
        data: {url: href, gtm: gtm, text: text, external: external},
        template: '<icon-link :linkUrl="url" :external="external" :gtm="gtm" :text="text" />'
      });
    }
  });
});
